
import React, { useEffect, useState } from 'react';
import { Grid, Typography, CircularProgress, Box, Skeleton, Snackbar, Alert } from '@mui/material';
import DashboardContainer from './components/DashboardContainer';
import StatusSection from './components/StatusSection';
import DeviceInformation from './components/DeviceInformation';
import LocationSection from './components/LocationSection';
import SolarPerformance from './components/SolarPerformance';
import PumpPerformance from './components/PumpPerformance';
import NetMetering from './components/NetMetering';
import PastSessions from './components/PastSessions';
import SystemStats from './components/SystemStats';
import { useAuth } from '../../AuthContext';
import RPMMeter from './components/RPMMeter';
import AlertsDisplay from './components/AlertsDisplay';
import { useParams, useNavigate } from 'react-router-dom';

const IndividualPump = () => {
 // const { imei } = useParams();
  const {
    pumpStats,
    loading,
    error,
    setValue,
    fetchData,
    fetchPumpStats,
    fetchPumpRunningStatus,
    fetchPumpSessions,
    setError,
  } = useAuth();
  // const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };


  if (loading) {
    return (
      <DashboardContainer>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <CircularProgress size={60} />
        </Box>
        <Grid container spacing={3}>
          {[...Array(8)].map((_, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Skeleton variant="rectangular" height={200} />
            </Grid>
          ))}
        </Grid>
      </DashboardContainer>
    );
  }

  if (error) {
    return (
      <DashboardContainer>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        </Box>
      </DashboardContainer>
    );
  }

  if (!pumpStats) {
    return (
      <DashboardContainer>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <Typography variant="h6">
            No pump data available. Please select a pump.
          </Typography>
        </Box>
      </DashboardContainer>
    );
  }

  return (
    <DashboardContainer>
        <Snackbar
        style={{fontSize:'2rem'}}
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Typography variant="h4" gutterBottom sx={{ mb: 2, fontWeight: 600 }}>
        Solar Pump Monitoring Dashboard
      </Typography>

      <StatusSection showSnackbar={showSnackbar} />

      <Grid container spacing={3} sx={{ alignItems: 'stretch' }}>
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <DeviceInformation sx={{ flex: 1 }} />
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <LocationSection sx={{ flex: 1 }} />
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <RPMMeter sx={{ flex: 1 }} />
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <AlertsDisplay sx={{ flex: 1 }} />
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <SolarPerformance sx={{ flex: 1 }} />
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <PumpPerformance sx={{ flex: 1 }} />
        </Grid>
        {/* <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <NetMetering sx={{ flex: 1 }} />
        </Grid> */}
        <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
          <PastSessions sx={{ flex: 1 }} />
        </Grid>
        <Grid item xs={12}md={6} sx={{ display: 'flex' }}>
          <SystemStats sx={{ flex: 1 }} />
        </Grid>
      </Grid>

    
    </DashboardContainer>
  );
};

export default IndividualPump;




  // useEffect(() => {
  //   console.log('IndividualPump useParams imei:', imei);
  //   if (imei) {
  //     setValue(imei);
  //     console.log('Fetching data for imei:', imei);
  //     Promise.all([
  //       fetchData(),
  //       fetchPumpStats(),
  //       fetchPumpRunningStatus(),
  //       fetchPumpSessions(),
  //     ]).catch(err => {
  //       console.error('Error fetching pump data:', err);
  //       setError('Failed to load pump data');
  //     });
  //   } else {
  //     console.log('No imei provided, redirecting to pumps');
  //     setError('No pump IMEI provided');
  //     navigate('/pumps', { state: { error: 'No pump IMEI provided' } });
  //   }
  // }, [imei, setValue, fetchData, fetchPumpStats, fetchPumpRunningStatus, fetchPumpSessions, setError, navigate]);